import { useCallback, useEffect, useState } from 'react';
import { useStoreActions, useStoreState } from '~/store/hooks';
import { extractErrorMessage } from '~/utils/error/error';
import { ICurrentClinic } from '~/services/api/clinic/types';

interface IUseClinicProps {
  clinic?: ICurrentClinic;
  loading: boolean;
}

const useClinic = (): IUseClinicProps => {
  const [loading, setLoading] = useState(false);

  const clinic = useStoreState(state => state.clinic.current);

  const showError = useStoreActions(actions => actions.snackbar.showError);
  const onGetMyClinic = useStoreActions(actions => actions.clinic.onGetMyClinic);

  const onMount = useCallback(async () => {
    try {
      setLoading(true);
      await onGetMyClinic();
    } catch (e) {
      showError(extractErrorMessage(e));
    } finally {
      setLoading(false);
    }
  }, [onGetMyClinic, showError]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  return { clinic, loading };
};

export default useClinic;
